var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"pie",style:({ height: `${_vm.size}px`, width: `${_vm.size}px` })},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"left"},[_c('span',{staticClass:"pie-animation"})])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"right"},[_c('span',{staticClass:"pie-animation"})])
}]

export { render, staticRenderFns }